import { render } from "./ModulBildergalerie.vue?vue&type=template&id=1502ef70"
import script from "./ModulBildergalerie.vue?vue&type=script&lang=js"
export * from "./ModulBildergalerie.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__